<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="600" persistent @input="closeModal">
      <v-card class="card">
        <v-card-title class="headline accent--text pb-4">
          {{ isShowMode ? 'Show' : isEdit ? 'Редактировать' : 'Добавить' }}
        </v-card-title>
        <v-card-text outlined tile class="border-top">
          <v-container class="px-0">
            <v-row>
                <v-col cols="12" class="pb-0">
                    <v-text-field
                      :disabled="isShowMode"
                      v-model="role.name"
                      label="Name"
                      placeholder="Add name"
                      @input="$v.role.name.$touch()"
                      @blur="$v.role.name.$touch()"
                      :error-messages="errorMessages.name"
                    />
                  </v-col>

                </v-row>
              </v-container>
</v-card-text>

        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn text color="lightGrey" @click="closeModal">{{ isShowMode ? 'Закрыть' : 'Отменить' }}</v-btn>
          <v-btn
            :loading="saveBtnLoading"
            :disabled="isShowMode"
            v-if="!isShowMode"
            color="success"
            text
            @click="saveRole"
          >
            {{ isEdit ? 'Сохранить' : 'Создать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Role } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: Object
  },

data: () => ({
    role: new Role(),
  }),

  validations() {
    return {
      role: {
        name: { required }
      }
    }
  },

computed: {
    isEdit() {
      return this.selectedItem?.id
    },
    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.role.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.role[key])
      })

      return allErrors
    }
  },

  methods: {
saveRole() {
      this.$emit('saveRole', this.role)
    },

    resetModal() {
      this.$v.$reset()
      this.role = new Role()
    },

    closeModal() {
      this.role = new Role()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(val) {
      this.role = val ? Role.buildFromAPI(val) : new Role()
    },

    dialog(val) {
!val && this.resetModal()
    }
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.card >>> .v-label.theme--light {
  font-size: 14px;
  color: rgba(55, 71, 79, .8) !important;
}

.card >>> .v-label.v-label--active.theme--light {
  font-size: 16px;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important
}
</style>
